// Accounts and Journals save the editable primary description in accountNames.
// Imported aliases can remain on the record after that description is edited.
export const getTransactionDescription = (transaction, fallback = "") =>
  [
    transaction?.accountNames,
    transaction?.Description,
    transaction?.description,
  ].find((value) => value != null && String(value).trim()) ?? fallback;

export const hasMissingTransactionDescription = (transaction) =>
  !String(getTransactionDescription(transaction)).trim();

export const transactionDescriptionsMatch = (left, right) => {
  const description = getTransactionDescription(left);
  return (
    Boolean(description) && description === getTransactionDescription(right)
  );
};
